module.exports = __webpack_public_path__ + "static/donor_pic-2d4e08d6d551e1343d886ad73ec138f0.png";